import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import { P1 } from '@root/gatsby-contentful-core/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';
import { toRgba } from '@root/gatsby-contentful-core/src/utils/colors';

export default function EventListing({
  eventsFileData,
  eventColor,
}) {
  return (
    <div
      css={[
        styles.eventListingContainer,
        {
          backgroundColor: toRgba(eventColor, 0.25),
        },
      ]}
    >
      <P1 css={styles.bold}>Key dates</P1>
      <ul
        css={styles.list}
      >
        {Object.entries(eventsFileData.national).map(([rawDateString, event], i) => {
          const date = new Date(rawDateString);
          const month = date.toLocaleString('default', { month: 'long' }); // eslint-disable-line object-curly-newline
          const day = date.getDate() + 1;

          return (
            <li
              css={styles.listItem}
              key={i}
            >
              <P1><span css={styles.bold}>{month} {day}</span> – {event}</P1>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

EventListing.propTypes = {
  eventColor: PropTypes.string,
  eventsFileData: PropTypes.shape({
    national: PropTypes.object,
  }),
};

const styles = StyleSheet.create({
  eventListingContainer: {
    width: '100%',
    padding: 20,
    marginTop: 40,
    borderRadius: 6,
    ...Responsive.md({
      display: 'none',
    }),
  },
  bold: {
    fontWeight: 'bold',
  },
  list: {
    listStyle: 'none',
  },
  listItem: {
    margin: '16px 0 0',
  },
});

